import axios from './config';

export const getLevels = ({ queryStr, params }) => {
  return axios.get(`/levels?${queryStr}`, { params }).then(res => res.data.data);
};
